import React from "react";
import PropTypes from "prop-types";
import "./passwordRequirements.css";

const PasswordRequirements = ({ password }) => {
  const requirements = [
    {
      text: "At least 8 characters",
      isMet: password.length >= 8,
    },
    {
      text: "At least 1 number",
      isMet: /[0-9]/.test(password),
    },
    {
      text: "At least 1 uppercase letter",
      isMet: /[A-Z]/.test(password),
    },
    {
      text: "At least 1 lowercase letter",
      isMet: /[a-z]/.test(password),
    },
    {
      text: "At least 1 special character",
      isMet:
        /^(?!\s)(?=.*[ !"#$%&'()*+,\-./:;<=>?@[\]\\^_`{|}~])(?!.*\s$).+$/.test(
          password
        ),
    },
  ];

  return (
    <div className="requirements-container">
      <div className="requirements-title">Password Requirements:</div>
      {requirements.map((requirement, index) => (
        <div
          key={index}
          className={`requirement-item ${requirement.isMet ? "met" : "unmet"}`}
        >
          <span className="requirement-icon">
            {requirement.isMet ? "✓" : "✕"}
          </span>
          {requirement.text}
        </div>
      ))}
    </div>
  );
};

PasswordRequirements.propTypes = {
  password: PropTypes.string.isRequired,
};

export default PasswordRequirements;
